import React, { useCallback, useMemo } from 'react'

import { useMenu } from 'hooks/use-menu'
import { billingPath } from 'routes/url-constants'
import { Icon, IconType } from 'components/atoms/Icon'
import Header from 'components/molecules/Header'
import Menu from 'components/molecules/Menu'

import classes from './style.module.css'

export const BillingHeader: React.FC = () => {
  const { menuLinks, isMenuOpen, toggleMenu } = useMenu(billingPath)

  const onKeyPressHandler = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') toggleMenu()
    },
    [toggleMenu],
  )

  const leftButton = useMemo(
    () => (
      <div className={classes.leftButton} onClick={toggleMenu} role="button" tabIndex={0} onKeyPress={onKeyPressHandler}>
        <Icon type={IconType.Menu} width="36px" height="36px" />
      </div>
    ),
    [onKeyPressHandler, toggleMenu],
  )

  return (
    <>
      <Header leftButton={leftButton} headerName="Счета и оплаты" />
      <Menu show={isMenuOpen} toggle={toggleMenu} navLinks={menuLinks} />
    </>
  )
}

export default BillingHeader
